import { NEWS_URL } from '../constans';
import { apiSlice } from './apiSlice';

const historyApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getProjectNews: builder.query({
      query: (projectId) => ({
        url: `${NEWS_URL}/${projectId}`,
        method: 'GET',
      }),
      keepUnusedDataFor: 5,
      providesTags: ['News'],
    }),
    getNews: builder.query({
      query: (params) => ({
        url: NEWS_URL,
        method: 'GET',
        params: { ...params },
      }),
      keepUnusedDataFor: 5,
      providesTags: ['News'],
    }),
    getNewsFilterData: builder.query({
      query: (params) => ({
        url: `${NEWS_URL}/filter`,
        method: 'GET',
        params: { ...params },
      }),
      keepUnusedDataFor: 5,
    }),
    setNewsStage: builder.mutation({
      query: (data) => ({
        url: `${NEWS_URL}`,
        method: 'POST',
        body: data,
      }),
      keepUnusedDataFor: 5,
      invalidatesTags: ['News']
    }),
    changeNewsVisibility: builder.mutation({
      query: (id) => ({
        url: `${NEWS_URL}/visibility/${id}`,
        method: 'POST',
      }),
      keepUnusedDataFor: 5,
      invalidatesTags: ['News']
    }),
    createUpdateNews: builder.mutation({
      query: (data) => ({
        url: `${NEWS_URL}/${data?.projectId}`,
        method: 'POST',
        body: data,
      }),
      keepUnusedDataFor: 5,
      invalidatesTags: ['Project', 'News']
    }),
    getProjectNewsItem: builder.query({
      query: (data) => ({
        url: `${NEWS_URL}/item/${data?.newsId}`,
        method: 'GET',
      }),
      keepUnusedDataFor: 5,
      // providesTags: ['NewsItem'],
    }),
  }),
});

export const {
  useGetNewsQuery,
  useGetProjectNewsQuery,
  useSetNewsStageMutation,
  useGetNewsFilterDataQuery,
  useChangeNewsVisibilityMutation,
  useCreateUpdateNewsMutation,
  useGetProjectNewsItemQuery
} = historyApiSlice;
